import { render, staticRenderFns } from "./Posterdragger.vue?vue&type=template&id=7f5f84b9"
import script from "./Posterdragger.vue?vue&type=script&lang=js"
export * from "./Posterdragger.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports